import React from "react"
import styled from "styled-components"
import { RadioButton, VerticalSpacer } from "@omnichannel/egr-common-ui"

const MainBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 0 0.2rem 0;
`

const LabelBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 1.2rem;
  color: #2f2f2f;
`

const OptionBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 0;
`

function DeliveryOptionBox(props) {
  return (
    <MainBox>
      <LabelBox>Delivery Option?</LabelBox>
      <OptionBox>
        <RadioButton
          disabled={props.disabled}
          selected={props.isDelivery === true}
          label="Delivery"
          size="large"
          onClick={() => {
            if (!props.disabled) props.setIsDelivery(true)
          }}
        />
        <VerticalSpacer width={"1.6rem"} />
        <RadioButton
          disabled={props.disabled}
          selected={props.isDelivery === false}
          label="Branch Pick Up"
          size="large"
          onClick={() => {
            if (!props.disabled) props.setIsDelivery(false)
          }}
        />
      </OptionBox>
    </MainBox>
  )
}

export default DeliveryOptionBox
